import React from 'react';
import { useTranslation } from 'react-i18next';
import { userType } from '../../types';

MemberAssignedUserRow.propTypes = {
    user: userType.isRequired,
};

function MemberAssignedUserRow(props) {
    const {
        user,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="detail-list-row">
            <div className="user-cell member-assigned-user-row--racf">{user.racf}</div>
            <div className="user-cell member-assigned-user-row--user-code">{user.userCode}</div>
            <div className="user-cell member-assigned-user-row--name">{user.name}</div>
            <div className="user-cell member-assigned-user-row--email">{user.email}</div>
            <div className="user-cell member-assigned-user-row--suspended">{user.suspended ? t('misc.yes') : t('misc.no')}</div>
            <div className="user-cell member-assigned-user-row--active">{user.active ? t('misc.yes') : t('misc.no')}</div>
        </div>
    );
}

export default MemberAssignedUserRow;
